(function(document, window, $) {
    'use strict';

    var Site = window.Site;

    $(document).ready(function($) {
        Site.run();

        //$(document).on('click','[data-type="models"]', function(e) {
        //
        //    var url = $(this).data('url');
        //
        //    bootbox.dialog({
        //        title: "That html",
        //        message: ' <div id="modelsDiv" data-url="'+ url +'"/>'
        //    });
        //
        //    $('#modelsDiv').selfLoadable();
        //});


        $(document).on('click','[data-makeinvoice]', function(e){
            var target = $(this).attr('data-makeinvoice');
            var l = Ladda.create(this);
            l.start();

            $.post(target)
                .done(function(data){
                    if (data.status){
                        if (data.message) window.inMessage(data.message);

                       // $('#filter').trigger('filter:refresh');

                    }else{
                        window.errorsCheck(data);
                    }

                })
                .always(function() { l.stop(); });
        });


    //    $('#commentform').submit(function(event){
        $(document).on('submit','#commentform', function(event){
            event.preventDefault();
            var comment = $('#commentinput').val();
            $.post( $(this).attr('action'), $(this).serialize())
                .done(function(data){
                    $('#commentinput').val('');
                    if (data.html!=undefined) $('#commentslist').prepend(data.html);
                })
                .fail(function(){
                    $('#commentinput').val(comment);
                })
                .always(function(){

                })

        });

        $(document).on('click','[data-type="deletecomment"]', function(e){
            var id = $(this).attr('data-id');

            var r = confirm("Sunteti sigur ca doriti sa stergeti?");
            if (r == true) {

                $.post( $(this).attr('data-url'), {'id':id, '_method':'delete'})
                    .done(function(data){
                        $('#comment'+id).remove();
                    })
                    .fail(function(){

                    })
                    .always(function(){

                    })


            }

        });


        $(document).on('change','[data-interlock]', function(e){
            var $target = $('[name="'+$(this).data('interlock')+'"]');
            if ($(this).prop('checked')){
                //is enough to remove the other one
                $target.prop("checked", false);
            }
        });

        $(document).on('click','[data-foldedmenu]', function(e) {

            e.preventDefault();
            var $body = $('body');
            var mode = 1;
            if ($(this).hasClass('active')){
                $(this).removeClass('active');
                $body.removeClass('site-menubar-fold');
                // $body.trigger('private-mode-changed');
                mode = 0;
            }else{
                $(this).addClass('active');
                $body.addClass('site-menubar-fold');
                //$body.trigger('private-mode-changed');
            }

            var url = $(this).data('href');

            $.post(url, { 'mode': mode})
                .done(function(data){
                })
        });


        if ($('#slidepanelopener').length){
            $('#slidepanelopener').trigger('click');
        }

        $(document).on('click','.btn-repeater', function(e){
            e.preventDefault();
            var $target = $(this).closest('.input-group');
            var $clone = $target.clone();

            $clone.find('input').val('');
            $clone.addClass('repeater-clone');
            $target.parent().append($clone);
        });

        $(document).on('click','.btn-repeater-delete', function(e){
            e.preventDefault();
            var $target = $(this).closest('.input-group').remove();
        });

        $(document).on('click','.gotourlinput', function(e){
            e.preventDefault();

            var $input = $(this).parent().parent().find('input');
            if ($input == undefined) return;

            var url = $input.val();
            if (validURL(url)){
                var win = window.open(url, '_blank');
                win.focus();
            }
        });

        $(document).on('click','.gotolink', function(e){
            e.preventDefault();
            e.stopPropagation();
            var url = $(this).attr('href');
            if (url != undefined) {
                var win = window.open(url, '_blank');
                win.focus();
            }
        });

        function validURL(str) {
            var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
                '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
            return !!pattern.test(str);
        }

        $(document).on('click','[data-getfrommodal]', function(e){
            var url = $(this).attr('data-getfrommodal');
            var l = Ladda.create(this);
            var aditive = 0;
            if ($(this).hasClass('aditive')) aditive = 1;
            l.start();
            $.post(url, { selected : window.getModalSelected()})
                .done(function(data){
                    if (data.status){
                        if (data.message) window.inMessage(data.message, {type:data.message_type});
                        $.featherlight.current().close();
                        if (aditive){
                            $(window.modalreturntarget).append(data.html);

                        }else {
                            $(window.modalreturntarget).html(data.html);
                        }
                    }else{
                        window.errorsCheck(data);
                    }
                })
                .always(function() { l.stop(); });
        });

        $(document).on('click','[data-fmodal]', function(e){
            $(this).featherlight();
            window.modalreturntarget = $(this).attr('data-fmodalreturn');
        });


        $(document).on('click','[data-bridgeclick]', function(e){
            var target = $(this).attr('data-bridgeclick');
            var data = $(this).attr('data-bridgedata');
            var l = Ladda.create(this);
            l.start();

            $.post(target, { bridgedata : data})
                .done(function(data){
                    if (data.status){
                        if (data.message) window.inMessage(data.message, {type:data.message_type});
                        if (data.replace != undefined && data.replacecontent != undefined)
                            $(data.replace).html(data.replacecontent);
                        //  $('#filter').trigger('filter:refresh');

                    }else{
                        window.errorsCheck(data);
                    }

                })
                .always(function() { l.stop(); });
        });

        $(document).on('click','[data-republish]', function(e){
            var target = $(this).attr('data-republish');
            var l = Ladda.create(this);
            l.start();

            $.post(target)
                .done(function(data){
                    if (data.status){
                        if (data.message) window.inMessage(data.message, {type:data.message_type});

                        $('#filter').trigger('filter:refresh');

                    }else{
                        window.errorsCheck(data);
                    }

                })
                .always(function() { l.stop(); });
        });


        $(document).on('click','[data-verifier-at-date]', function(e){
            $('#verified_at_date').toggle();
        });


        $(document).on('click','#verifier-at-date-button', function(e){



            var target = $(this).attr('data-href');
            var updateTarget = $(this).attr('data-update');
            var l = Ladda.create(this);
            l.start();

            $.post(target, $('#verifieratdateform').serialize())
                .done(function(data){
                    if (data.status){
                        if (data.html){
                            $(updateTarget).html(data.html);
                        }
                        $('#filter').trigger('filter:refresh');
                        $('#verified_at_date').toggle();

                    }else{
                        window.errorsCheck(data);
                    }

                })
                .always(function() { l.stop(); });

        });

        $(document).on('click','[data-verifier]', function(e){
            var target = $(this).attr('data-verifier');
            var updateTarget = $(this).attr('data-update');
            var l = Ladda.create(this);
            l.start();

            $.post(target)
                .done(function(data){
                    if (data.status){
                        if (data.html){
                            $(updateTarget).html(data.html);
                        }
                        $('#filter').trigger('filter:refresh');

                    }else{
                        window.errorsCheck(data);
                    }

                })
                .always(function() { l.stop(); });
        });




        $(document).on('click','[data-ajaxsimple]', function(e){
            var target = $(this).attr('data-ajaxsimple');
            var $target = $(target);

            var triggerTarget = $(this).attr('data-triggertarget');
            var triggerEvent =  $(this).attr('data-triggerevent');

            var l = Ladda.create(this);
            l.start();

            var closepanel = $(this).attr('data-closepanel');

            $.post($target.attr('action'), $target.serialize())
                .done(function(data){
                    if (data.status){
                        if (closepanel=='true') $('.slidePanel-close').trigger('click');
                        if (data.replace != undefined && data.replacecontent != undefined)
                            $(data.replace).html(data.replacecontent);

                        //  console.log('triggerTarget'+triggerTarget);
                        if (triggerTarget != undefined && triggerEvent != undefined) $(triggerTarget).trigger(triggerEvent);
                        if (data.message) window.message(data.message);
                    }else{
                        window.errorsCheck(data);
                    }

                })
                .always(function() { l.stop(); });
        });

        $(document).on('click','[data-modalfire]',function(e){
            window.modalfire = $(this).data('modalfire');
        });


        $(document).on('click','[data-checkallbyclass]',function(e){
            var caclass = $(this).data('checkallbyclass');
            var check = $(this).prop('checked');
            $('.'+caclass).prop('checked', check);
        });

        $(document).on('click', '[data-type="date-presel"]', function(e){
            var $parent = $(this).closest('.dropdown-menu');
            var v1 = $(this).data('v1');
            var v2 = $(this).data('v2');
            if (v1){
                var target1 = $parent.data('sel1');
                if (target1) $(target1).val(v1);
            }

            if (v2){
                var target2 = $parent.data('sel2');
                if (target2) $(target2).val(v2);
            }

            if (target1 != undefined) $(target1).trigger('change');

        });


        $(document).on('click','[data-type="delete-file"]', function(e){
            e.preventDefault();
            //console.log("Clicked");
            var id = $(this).data('id');
            $('#file-upload-'+id).replaceWith('<input type="hidden" name="delete_files[]" value="'+id+'">');
        });

        $(document).on('click','[data-mine]', function(e) {
            e.preventDefault();
            var active;
            if ($(this).hasClass('btn-outline')){
                $(this).removeClass('btn-outline');
                active = 1;
            }else{
                $(this).addClass('btn-outline');
                active = 0;
            }
            $('input[name=only_mine]').val(active);
            $('#filter').trigger('filter:refresh');

        });

        $(document).on('click','[data-switchactive]', function(e) {
            e.preventDefault();
            var active;
            if ($(this).hasClass('btn-outline')){
                $(this).removeClass('btn-outline');
                $(this).addClass('active');
                active = 1;
            }else{
                $(this).addClass('btn-outline');
                $(this).removeClass('active');
                active = 0;
            }
        });


        $(document).on('click','[data-privemode]', function(e) {

            e.preventDefault();
            var $body = $('body');
            var mode = 1;
            if ($(this).hasClass('active')){
                $(this).removeClass('active');
                $body.removeClass('private-mode-enabled');
                $body.trigger('private-mode-changed');
                mode = 0;
            }else{
                $(this).addClass('active');
                $body.addClass('private-mode-enabled');
                $body.trigger('private-mode-changed');
            }

            var url = $(this).data('href');

            $.post(url, { 'mode': mode})
                .done(function(data){
                })
        });

        $(document).on('click','[data-deletetarget]', function(e) {

            var target = $(this).data('deletetarget');

            $(this).closest(target).remove();
        });


        $(document).on('click','[data-closable]', function(e) {

            var target = $(this).data('closable');
           // var input = $(this).closest(target).find('input').first();
            var input = $(this).parent().parent().parent().parent().find('.form-control').first();
            $(this).closest(target).remove();


            if (input != undefined) {
                input.trigger('change');
            }
        });


        $(document).on('click','[data-popup]', function(e) {

            var url = $(this).data('href');

            window.open(url,"presentation", "fullscreen=yes,scrollbars=yes");
        });



        $(document).on('change','[data-type="modelselect"]', function(e) {
            var $target = $(this).parent().find('.translatable');
            var content = $(this).parent().find('[data-content="'+$(this).val()+'"]').html();

            if ($target.hasClass('editor')){
                tinyMCE.get($target.attr('id')).setContent(content);
            }else {
                $target.val(content);
            }

        });


        $(document).on('click','[data-type="autotranslate"]', function(e){
            var $target = $(this).parent().find('.translatable');

            $(window).trigger('beforeajaxsaving');
            var url = $(this).data('url');
            var to = $(this).parent().data('lang');
            var $fromLangTarget = $(this).closest('.form-group').find('.translatable').first();
            var from = $fromLangTarget.parent().data('lang');
            var what = $fromLangTarget.val();

            $.post(url, { 'from': from, 'to': to, 'what':what})
                .done(function(data){
                    if (data.translation !=undefined){
                        if ($target.hasClass('editor')){
                            tinyMCE.get($target.attr('id')).setContent(data.translation);
                        }else {
                            $target.val(data.translation);
                        }
                    }
                })

        });

        $(document).on('click','[data-filterable]', function(e){

            var targetinput = $(this).data('filterable');
            $('#filter [name="'+targetinput+'"]').first().val($(this).data('filtervalue')).trigger('change');
            $('[data-filterable="'+targetinput+'"').removeClass('active');
            $(this).addClass('active');
        });


        $(document).on('click','[data-type="previewfullscreen"]', function(e){
            e.preventDefault();


            var target = $(this).attr('data-form');
            var $target = $(target);

            var l = Ladda.create(this);
            l.start();
            $(window).trigger('beforeajaxsaving');
            $.post($(this).data('href'), $target.serialize())
                .done(function(data){
                    if (data.url != undefined){
                        initPreview(data.url);

                    }

                })
                .always(function() { l.stop(); });

        });

        $(document).on('click','[data-previewfullscreen]', function(e){
            e.preventDefault();

            initPreview($(this).data('previewfullscreen'));

        });

        $(document).on('click','[data-pinstoinset]', function(e){
            e.preventDefault();



            if ($(this).hasClass('disabled')) return;
            var target = $(this).data('pinstoinset');
            var type = $(this).data('pinstype');
            var url = $(this).data('pinsurl');
            var l = Ladda.create(this);
            l.start();
            var self = this;
            $.post(url, {'type':type})
                .done(function(data){
                    if (data.html != undefined){
                        $(target).append(data.html);
                        var input =$(target).parent().parent().parent().parent().find('.form-control').first();
                        if (input != undefined) input.trigger('change');
                    }

                })
                .always(function() { l.stop(); $(self).addClass('disabled') });

        });


        $(document).on('click','[data-type="opinion"]', function(e){
            var isactive = ! $(this).hasClass('btn-outline');
            var value = $(this).attr('data-value');

            $(this).parent().find('.btn').addClass('btn-outline');

            if (!isactive)
                $(this).removeClass('btn-outline');
            else{
                value = 0;
            }

            var url = $(this).parent().attr('data-url');
            if (url){
                $.post(url, {'like': value});
            }
        });




        window.initOnSelectable();

        //we hide the multi delete
        $('[data-type="deletemulti"]').each(function(){
            $(this).slideUp(0);
            var target = $(this).attr('data-target');
            var self = this;

            $(target).on('selected:on', function(){
                $(self).slideDown();
            });

            $(target).on('selected:off', function(){
                $(self).slideUp();
            });

        });

        //delete single
        $(document).on('click','[data-type="deletesingle"]', function(e){
            e.preventDefault();

            var url = $(this).attr('data-href');

            var that = $(this);

            //alertify.confirm( "Delete ?", function () {
            //    $(that).closest('.model-item').fadeOut();
            //    sendPost('#', $(that).closest('.model-item'), '', unfadeElement);
            //});




            bootbox.confirm("Are you sure you want to delete?", function(result) {
                if (result) {

                    var mode = $(that).attr('data-mode');
                    if (typeof mode !== 'undefined'){
                        if (mode == 'panel') {
                            $('.slidePanel-close').trigger('click');
                        }
                    }

                    $(this).addClass('disabled');

                    if (url.indexOf('#') == 0){ //we just want to submit the form with the method delete
                        $(url+' input[name=_method]').val('DELETE');
                        $(url).submit();
                    }else {
                        $.post(url, {'_method': 'delete'})
                            .done(function (data) {
                                var eventAfter = $(that).attr("data-eventafter");
                                if (typeof eventAfter !== 'undefined')  $('body').trigger(eventAfter);

                                var callbackAfter = $(that).attr("data-callbackafter");
                                var fn = window[callbackAfter];

                                if (typeof fn === "function") {
                                    fn();
                                }
                            })
                            .fail(function () {
                                inMessage('There was a problem', {message: 'We encountered a problem', type: 'error'});
                            })
                            .always(function () {

                            });
                    }
                }
            });

        });


        //delete multi
        $(document).on('click','[data-type="deletemulti"]', function(e){
            e.preventDefault();

            var target = $(this).attr('data-target');
            //var url = $(this).attr('data-url');
            var url = $(this).attr('data-href');

            var $selectedIds = getSelectedItemsValues(target);

            if ($selectedIds.length == 0){
                inErrorMessage('Select some items please');
                return;
            }


            var filterSelector = $(target).attr('data-filter');

            var filter = $(target).attr('data-filter');

            var self = this;

            bootbox.confirm("Sunteti sigur ca doriti sa stergeti?", function(result) {
                if (result) {
                    $(this).addClass('disabled');
                    $.post(url, {'ids': $selectedIds, '_method': 'delete'})
                        .done(function (data) {

                            $(filter).trigger('filter:refresh');
                        })
                        .fail(function () {
                            inMessage('There was a problem', {message: 'We encountered a problem', type: 'error'});
                        })
                        .always(function () {
                            $(self).removeClass('disabled');
                        });
                }
            });

        });


        //delete multi
        $(document).on('click','[data-type="unionmulti"]', function(e){
            e.preventDefault();

            var target = $(this).attr('data-target');
            //var url = $(this).attr('data-url');
            var url = $(this).attr('data-href');

            var $selectedIds = getSelectedItemsValues(target);

            if ($selectedIds.length < 2){
                inErrorMessage('Va rugam sa selectati cel putin 2 elemente');
                return;
            }


            var filterSelector = $(target).attr('data-filter');

            var filter = $(target).attr('data-filter');

            var self = this;

            bootbox.confirm("Sunteti sigur ca doriti sa unificati?", function(result) {
                if (result) {
                    $(this).addClass('disabled');
                    $.post(url, {'ids': $selectedIds})
                        .done(function (data) {

                            $(filter).trigger('filter:refresh');
                        })
                        .fail(function () {
                            inMessage('There was a problem', {message: 'Am intampinat o problema', type: 'error'});
                        })
                        .always(function () {
                            $(self).removeClass('disabled');
                        });
                }
            });

        });



        function unfadeElement(element){
            $(element).fadeIn();
        }


        function sendPost(url, callbackOption, callbackOk, callbackFail ){

            inMessage('Bla bla bla', {message: 'Bla bla erased', type: 'error'});
            if (typeof callbackOk === "function") {
                callbackOk(callbackOption);
            }
            if (typeof callbackFail === "function") {
                callbackFail(callbackOption);
            }
        }


        //prevent slidepanel to show up when clicking on a button inside a table tr
        $(document).on('click','tr .btn', function(e){
            e.stopPropagation();
        });

        //filter button



        $(document).on('click','[data-type="filter-cleaner"]', function(e){
            e.preventDefault();
            var target = $(this).closest('form');
            $(target).trigger('filter:nofiltering');
            clear_form_elements(target);
            $(target).trigger('filter:clear');
            $(target).trigger('filter:filtering');
            $(target).trigger('filter:refresh');
            $('.page-header-actions [data-type="filterbutton"]').trigger('click');

        });



        //
        //$(document).on('click','[data-type="filterbutton"]', function(e){
        //    e.preventDefault();
        //    var target = $(this).attr('data-href');
        //
        //    ($(target).hasClass('in')) ? $(this).removeClass('active') : $(this).addClass('active');
        //
        //    $(target).collapse('toggle');
        //});


        $(document).on('click','[data-type="saveform"]', function(e){

            e.preventDefault();

            var target = $(this).attr('data-href');
            var $target = $(target);
            if (! $target.length) return;

            var back = $(this).attr('data-back');
            if (back) {
                var input ='<input type="hidden" name="backurl" value="'+back+'">';
                $(input).appendTo(target);
            }


            if ($(target)[0].checkValidity()) {
                $(target).submit();
            }else{
                window.inMessageError('Va rugam sa corectati erorile!');
                $(target+' :input:visible[required="required"]').each(function()
                {
                    if(!this.validity.valid)
                    {
                        $(this).closest('.form-group').addClass('has-error');

                    }else{
                        $(this).closest('.form-group').removeClass('has-error');
                    }
                });

                $(target+' :input').each(function() {
                    if (!this.validity.valid) {
                        $(this).closest('.form-group').addClass('has-error');
                    }
                });

                $(target+' .selectized[required="true"]').each(function()
                {
                    if(!this.validity.valid)
                    {
                        $(this).closest('.input-group').addClass('has-error');
                        $(this).closest('.form-group').addClass('has-error');

                    }else{
                        $(this).closest('.input-group').removeClass('has-error');
                        $(this).closest('.form-group').removeClass('has-error');
                    }
                });

            }

        });



        $(document).on('click','[data-type="gotourl"]', function(e){

            e.preventDefault();

            var url = $(this).attr('href');
            window.location = url;

        });

        $(document).on('click','[data-type="filterbutton"]', function(e){
            e.preventDefault();
            var target = $(this).attr('data-href');

            ($(target).hasClass('in')) ? $(this).removeClass('active') : $(this).addClass('active');

            $(target).collapse('toggle');
        });

        $('[data-type="filterbutton"]').each(function(){
            var target = $(this).attr('data-href');
            var isFiltered = $(target).find('form').first().attr('data-filtered');


            if (parseInt(isFiltered)) {
                $(this).addClass('active');
                $(this).trigger('click');
            }
        });





    });



})(document, window, jQuery);
